<template>

  <div id="grades">

    <div class="t-grade">高中教育阶段</div>
    <div class="c-grade">
        <div class="grade" v-for="(grade,index) in grades.slice(0,3) " :key="index"
          @click="select(grade)"
           v-track="{ name: 'select_grade_gz' }">
                <img :src="require('@/assets/grade/' + grade.img + '.png')" />
        </div>
    </div>


    <div class="t-grade">义务教育阶段</div>
    <div class="c-grade">
        <div class="grade" v-for="(grade,index) in grades.slice(3,12) " :key="index"
        @click="select(grade)"
         v-track="{ name: 'select_grade_yw' }"
        >
                <img :src="require('@/assets/grade/' + grade.img + '.png')" />
        </div>
        </div>
    </div>

</template>

<script>

export default {
  name: 'Grade',
  data(){
      return {

        grades : [
                        { text: '高一', value: 'G1', code: 'g', img:'a10' },
                        { text: '高二', value: 'G2', code: 'g', img:'a11'},
                        { text: '高三', value: 'G3', code: 'g', img:'a12' },
                        { text: '一年级', value: 'A1', code: 'x' , img:'a1'},
                        { text: '二年级', value: 'A2', code: 'x' , img:'a2'},
                        { text: '三年级', value: 'A3', code: 'x' , img:'a3'},
                        { text: '四年级', value: 'A4', code: 'x' , img:'a4'},
                        { text: '五年级', value: 'A5', code: 'x' , img:'a5'},
                        { text: '六年级', value: 'A6', code: 'x' , img:'a6'},
                        { text: '七年级', value: 'A7', code: 'c' , img:'a7'},
                        { text: '八年级', value: 'A8', code: 'c' , img:'a8'},
                        { text: '九年级', value: 'A9', code: 'c' , img:'a9'},
                    ],
      }
  },
  methods:{
      select(grade){
          this.$store.commit("cmtBindGradeInfo",{name:grade.text,value:grade.value});
          this.$router.back();

      }
  },
  components: {

  },
  mounted(){

  },
  created(){
    this.$store.dispatch('share/initShareParams')
  }
}
</script>

<style lang="scss">
    #grades{
        padding: 16px;
        .t-grade{
            font-size: 18px;
            margin-top: 15px;
            margin-bottom: 10px;
        }
        .c-grade{
            width: 100%;
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;
            .grade{
                flex: 1;
                width: 30%;
                min-width: 30%;
                max-width: 30%;
                overflow: hidden;
                margin-bottom: 15px;
                img{
                    width: 100%;
                }
            }
        }
    }
</style>
